module.exports = __webpack_public_path__ + "static/media/meetanshi_logo-removebg-preview.8f6eb157.png";